import * as types from "../../actions/actionTypes";

const sumObj = {
  payment: 0,
  receive: 0
};
const initialData = {
  data: {
    data: []
  },
  total_sum: sumObj,
  remain_sum: sumObj
};
const initialState = {
  errorDetail: "",
  loadingDetail: true,
  dataDetail: initialData,
  error: "",
  loading: false,
  data: {
    data: []
  },
  itemData: initialData,
  itemLoading: false,
  itemError: ""
};

const PettyCashierMonthlyReview = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_SUCCESS:
      return { ...state, data: action.payLoad, loading: false };
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.error };
    case types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        dataDetail: initialData,
        errorDetail: ""
      };
    case types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_SUCCESS:
      return { ...state, dataDetail: action.payLoad, loadingDetail: false };
    case types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_FAILURE:
      return { ...state, loadingDetail: false, errorDetail: action.error };

    case types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_SUCCESS:
      return { ...state, dataDetail: action.payLoad, processing: false };
    case types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_FAILURE:
      return { ...state, processing: false };

    case types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_REQUEST:
      return {
        ...state,
        itemLoading: true,
        itemData: initialData,
        itemError: ""
      };
    case types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_SUCCESS:
      return { ...state, itemData: action.payLoad, itemLoading: false };
    case types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_FAILURE:
      return { ...state, itemLoading: false, itemError: action.error };

    default:
      return state;
  }
};

export default PettyCashierMonthlyReview;
